var $bf47e45564e9fd15$exports = {};
$bf47e45564e9fd15$exports = {
    "more": `Daugiau element\u{173}`
};


export {$bf47e45564e9fd15$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
